export interface ICheckTokenData extends Components.Schemas.CheckTokenDto {}

export enum ECommonFormType {
  Add = 'add',
  Update = 'update'
}
